module.exports = __webpack_public_path__ + "img/img1.be40a5a7.png";